import React, { useMemo, useState } from "react";
import styles from "./DSIWorkflow.module.css";
import { ViewTabs } from "../../../../common/components";
import { useApi } from "../../../../common/hooks";
import { translate } from "../../../../common/providers";
import { AiWorkflowService } from "../../../../api";
import { WorkFlowHistory, WorkflowModels } from "./components";
import ExportImport from "../components/export-import/ExportImport";

const DSIWorkflow = () => {
	const { call: exportWorkflows } = useApi(AiWorkflowService.exportWorkflows);
	const { call: importWorkFlows } = useApi(AiWorkflowService.importWorkFlows);
	const [selectedTab, setSelectedTab] = useState(0);
	const handleChangeSelectedTab = (_, newTab) => {
		setSelectedTab(newTab);
	};
	const tabs = useMemo(
		() => [
			{ label: translate("dsi.workflows.tab.models.title"), component: <WorkflowModels /> },
			{ label: translate("dsi.workflows.tab.history.title"), component: <WorkFlowHistory /> },
		],
		[]
	);
	return (
		<div className={styles.main}>
			<div className={styles.header}>
				<div className={styles.tabs}>
					<ViewTabs
						noPadding
						noShadow
						selectedTab={selectedTab}
						tabs={tabs}
						onChange={handleChangeSelectedTab}
					/>
				</div>
				<ExportImport onExport={exportWorkflows} onImport={importWorkFlows} />
			</div>
			{tabs[selectedTab].component}
		</div>
	);
};

export default DSIWorkflow;
